import * as Yup from 'yup';
import { AudioOptionInput } from 'models';
import { ProgramSchemaValidation } from 'models/forms';

export const areOptionsEdited = (options: AudioOptionInput[]): boolean => {
  const optionsEdited = options.reduce((isCompleted, option) => {
    return (
      isCompleted ||
      option.duration !== null ||
      option.audioTrack.file !== '' ||
      option.padsTrack.file !== ''
    );
  }, false);
  return optionsEdited;
};

export const areOptionsCompleted = (options: AudioOptionInput[]): boolean => {
  const optionsCompleted = options.reduce((isCompleted, option) => {
    return (
      isCompleted && option.duration !== null && option.audioTrack.file !== ''
    );
  }, true);
  return optionsCompleted;
};

export const handleSchemaValidation = (): ProgramSchemaValidation => {
  return Yup.object().shape({
    name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
  });
};
